import { Empty, Typography } from "antd";

const { Title, Paragraph } = Typography;

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

/** Phase별 구현 전 임시 페이지 */
const PlaceholderPage = ({ title, description }: PlaceholderPageProps) => (
  <div className="app-main">
    <Title level={4}>{title}</Title>
    <Empty
      description={
        <span>
          {description || "이 페이지는 향후 단계(Phase)에서 구현됩니다."}
          <br />
          <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 8 }}>
            qnnp-finance 마이그레이션 로드맵 참조
          </Paragraph>
        </span>
      }
    />
  </div>
);

export default PlaceholderPage;
